import {Container} from '@mui/material';
import React, {FC, useState, useCallback, useRef, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {ToastSeverity, theme, useToast} from 'thermia-react-container';
import useIsMounted from '../../../hooks/useIsMounted';
import { useRegistrationService } from '../../../service/registrationService';
import {PartnerInfo} from "../../../types/registrationTypes";
import {OnBehalfOfService} from "../../../service/onBehalfOfService";
import AdminTabs from "../components/adminTabs";
import {useNavigate, useParams} from "react-router-dom";
import AdminPartnersSearch from "./components/adminPartnersSearch";
import AdminPartnersTable from "./components/adminPartnersTable";
import {useRefreshData} from "../../registration/hooks/useRefreshData";

const AdminPartners: FC = () => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('registrations');
  const { addToast } = useToast();
  const isMounted = useIsMounted();
  const { getPartners } = useRegistrationService(true);
  const [results, setResults] = useState<PartnerInfo[]>([]);
  const navigate = useNavigate();
  const refreshData = useRefreshData();

  let { search } = useParams<{ search: string }>();
  const lastSearchRef = useRef<string>('');
  const [textInput, setTextInput] = useState<string>(search ?? '');


  const searchPartners = useCallback(async ()=> {
    try {
      const searchTerm = textInput.trim();
      if(searchTerm === '') {
        return;
      }
      setLoading(true);
      const results = await getPartners(searchTerm);
      setResults(results);
    } catch (e) {
      if (isMounted) {
        addToast(t('registrations.general.noPartnerWasFound'), ToastSeverity.ERROR);
      }
    }
    if (isMounted) {
      setLoading(false);
    }
  }, [addToast, getPartners, isMounted, t, textInput]);

  useEffect(() => {
    if(search && search !== lastSearchRef.current) {
      lastSearchRef.current = search;
      setTextInput(search);
      searchPartners();
    }
  }, [search, searchPartners]);
  const setSearch = () => {
    navigate('/admin/partners/' + textInput.trim());
  }

  return (
    <Container maxWidth="xl" sx={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(50) }}>
      <AdminTabs tab={'partners'} />
      <AdminPartnersSearch 
        isLoadingResults={loading} 
        searchAction={setSearch} 
        setTextInput={setTextInput} 
        textInput={textInput} 
      />
      <AdminPartnersTable data={results} action={(partner:PartnerInfo) => {
        OnBehalfOfService.partner = partner;
        refreshData();
        navigate(`/unregistered-devices`);
      }} />
    </Container>
  );
};

export default AdminPartners;
